import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const NAV = [
  { to: "/",           label: "Overview",       icon: "grid" },
  { to: "/history",    label: "Backup history", icon: "clock" },
  { to: "/restore",    label: "Restore",        icon: "undo" },
];
const CONFIG_NAV = [
  { to: "/connectors", label: "Connectors",  icon: "link" },
  { to: "/schedules",  label: "Schedules",   icon: "timer" },
  { to: "/users",      label: "Users",       icon: "users" },
  { to: "/audit",      label: "Audit log",   icon: "list" },
  { to: "/settings",   label: "Tenant Settings", icon: "settings" },
];
const ADMIN_NAV = [
  { to: "/admin/tenants", label: "Tenants", icon: "admin" },
];

const ICONS: Record<string, React.ReactElement> = {
  grid:     <svg viewBox="0 0 16 16" fill="currentColor"><path d="M2 2h5v5H2zm7 0h5v5H9zm-7 7h5v5H2zm7 0h5v5H9z"/></svg>,
  clock:    <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 2a5 5 0 110 10A5 5 0 018 3zm-.5 2v4l3 1.5-.5 1L7 9.5V5h.5z"/></svg>,
  undo:     <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 2a6 6 0 00-6 6h2a4 4 0 014-4V2zm0 0v3l3-1.5L8 2zM2 8a6 6 0 006 6v-2a4 4 0 01-4-4H2z"/></svg>,
  link:     <svg viewBox="0 0 16 16" fill="currentColor"><path d="M4 8a4 4 0 004 4 4 4 0 004-4 4 4 0 00-4-4 4 4 0 00-4 4zm3 0a1 1 0 112 0 1 1 0 01-2 0z"/></svg>,
  timer:    <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 2a5 5 0 110 10A5 5 0 018 3zm-1 2v5h4V9H9V5H7z"/></svg>,
  list:     <svg viewBox="0 0 16 16" fill="currentColor"><path d="M2 2h12v1H2zm0 3h12v1H2zm0 3h8v1H2zm0 3h10v1H2z"/></svg>,
  users:    <svg viewBox="0 0 16 16" fill="currentColor"><path d="M6 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 1C3.8 8 1 9.1 1 11v1h10v-1c0-1.9-2.8-3-5-3zm7-2a2 2 0 100-4 2 2 0 000 4zm2 1h-1.4c-.6.3-1.3.5-2 .6C13 8.2 15 9.3 15 11v1h-2v-1c0-1-.5-1.8-1.3-2.4.4-.1.9-.1 1.3-.1 1.9 0 4 .9 4 2.5V13h-2v-1c0-.2 0-.4-.1-.6C14.5 11.1 14.5 10.8 14.5 11l-.5-.9c.1.2.2.4.2.7v1H12v-1c0-.5-.3-1-.8-1.4.5-.1 1-.2 1.3-.3z"/></svg>,
  settings: <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 5a3 3 0 100 6A3 3 0 008 5zm0 1a2 2 0 110 4A2 2 0 018 6z"/></svg>,
  admin:    <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 1L2 4v4c0 3.5 2.5 6.7 6 7.4 3.5-.7 6-3.9 6-7.4V4L8 1zm0 2l4 2v3c0 2.6-1.8 5-4 5.6C5.8 13 4 10.6 4 8V5l4-2z"/></svg>,
};

export default function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <nav className="sidebar">
      <div className="nav-logo">
        <div className="logo-row">
          <div className="logo-icon">
            <svg viewBox="0 0 18 18" fill="#0f1923"><path d="M9 2L3 5v4c0 3.5 2.5 6.7 6 7.4 3.5-.7 6-3.9 6-7.4V5L9 2z"/></svg>
          </div>
          <div>
            <div className="logo-name">FinBackup</div>
            <div className="logo-tag">Financial Data Protection</div>
          </div>
        </div>
      </div>

      <div className="nav-section">Main</div>
      {NAV.map((item) => (
        <NavLink key={item.to} to={item.to} end className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
          <span className="nav-icon">{ICONS[item.icon]}</span>
          {item.label}
        </NavLink>
      ))}

      <div className="nav-section">Config</div>
      {CONFIG_NAV.map((item) => (
        <NavLink key={item.to} to={item.to} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
          <span className="nav-icon">{ICONS[item.icon]}</span>
          {item.label}
        </NavLink>
      ))}

      {user?.is_platform_admin && (
        <>
          <div className="nav-section">Platform</div>
          {ADMIN_NAV.map((item) => (
            <NavLink key={item.to} to={item.to} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
              <span className="nav-icon">{ICONS[item.icon]}</span>
              {item.label}
            </NavLink>
          ))}
        </>
      )}

      <div className="nav-org">
        <div className="org-pill">
          <span className="org-dot" />
          <span className="org-name">{user?.email ?? "Loading…"}</span>
        </div>
        <button className="btn-logout" onClick={logout}>Sign out</button>
      </div>
    </nav>
  );
}
